export enum Colors {
  primaryColor = '#169AF4',
  secondaryColor = '#F2FAFF',
  backgroundColor = '#F2FAFF',
}
